exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Discussion-ButtonExpand-Root {\n  border: 1px solid #979797;\n  border-radius: 3px;\n  color: #2c2e2f;\n  font-size: 12px;\n  font-weight: bold;\n  letter-spacing: 0.8px;\n  line-height: 17px;\n  text-align: center;\n  box-sizing: border-box;\n  padding: 10px;\n  text-transform: uppercase;\n  cursor: pointer;\n  user-select: none;\n  margin: 25px 60px;\n}\n@media (max-width: 480px) {\n  .Discussion-ButtonExpand-Root {\n    margin: 25px 20px;\n  }\n}\n", ""]);

// exports
